var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-two-warp wh-flex-center"},[_c('span',{staticClass:"title-txt"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }